import { FeatureFlagMap } from '../types/blp-feature-flags';

export default function GetFeatureFlags(): Promise<FeatureFlagMap> {
	return fetch(`${process.env.REACT_APP_PLATFORM_API_HOST}/v3/feature-flags`).then((res) => {
		if (res.ok) {
			if (res.headers.get('content-type')?.includes('application/json')) {
				return res.json();
			}
			throw new Error('Invalid content type');
		} else {
			throw new Error('Request failed');
		}
	}).catch((error) => {
		console.error('Error fetching blp feature flags:', error);
		return {};
	});
}
